<template>
  <div class="check-wrap">
    <!--<div class="body-check" v-if="identityWay === identityStatus.isIDCard">-->
      <!--<h1>将通过人脸识别验证考生身份</h1>-->
      <!--<button class="fill-btn" @click="goToTencent">开始验证</button>-->
    <!--</div>-->
    <div v-if="identityWay === 1 || identityWay === 2">
      <div class="photo-check flex-content-between" v-show="!faceCheckLoading">
        <div class="camera-wrap" v-show="!faceSuccess">
          <div class="no-camera flex-row-center" v-show="!showCamera">
            <p class="icon-camera"></p>
            <span class="box left-top"></span>
            <span class="box right-top"></span>
            <span class="box left-bottom"></span>
            <span class="box right-bottom"></span>
          </div>
          <camera
            class="camera"
            ref="checkCamera"
            :video-width="videoWidth"
            :video-height="videoHeight"
            :photo-width="videoWidth"
            :photo-height="videoHeight"
            :upload-path="photoPath"
            @openVideo="openVideo"
            @handleError="handleError"
            @photoReport="setCameraImg"
          ></camera>
        </div>
        <div class="operate-wrap" v-show="!faceSuccess">
          <h1>{{ tipTitle }}</h1>
          <div class="btn-wrap">
            <button :class="{ 'fill-btn': !hasFaceResult, 'empty-btn': hasFaceResult, 'btn-disabled': !isOpenCamera }" :disabled="!isOpenCamera" @click="getPhoto">{{ !hasFaceResult ? '开始拍照' : '重新拍照'}}</button>
            <button v-show="hasFaceResult" class="fill-btn" @click="goToVideoCheck">跳过</button>
          </div>
          <div class="tip-wrap">
            <p class="sub-text title">操作提示：</p>
            <p class="sub-text">
              1.请保持光源充足，不要逆光操作；<br/>2.请保证脸部正面面向摄像头，整个脸部能够全部进入画面；
            </p>
          </div>
        </div>
        <div class="face-success" v-show="faceSuccess">
          <h1>照片识别成功</h1>
          <p class="icon-success"></p>
          <p class="normal-text">身份验证成功，自动进入下一步～</p>
        </div>
      </div>
      <div class="loading-wrap" v-show="faceCheckLoading">
        <h1>照片正在识别…</h1>
        <div>
          <loading
            :box-size="16"
            :round-size="4"
            :color="'#306FFF'">
          </loading>
        </div>
      </div>
    </div>
    <div class="video-check" v-if="identityWay === identityStatus.isFail">
      <video-record @handleError="handleError" @success="success"></video-record>
    </div>
    <camera-error-modal v-show="showCameraErrorTip" @close="showCameraErrorTip = false"></camera-error-modal>
  </div>
</template>

<script>
import VideoRecord from './VideoRecord'
import { get, post } from '@/utils/ajax'
import Camera from '../components/OpenCamera'
import { mapState } from 'vuex'
import Loading from '@/components/Loading'
import CameraErrorModal from '../components/CameraErrorModal'
export default {
  components: {
    Camera,
    VideoRecord,
    Loading,
    CameraErrorModal
  },
  computed: {
    ...mapState(['user'])
  },
  data() {
    return {
      examId: 0,
      // isIDCard: true, // 是否身份证报名
      // isFail: true, // 活体校验/拍照校验是否失败
      identityWay: 0,
      identityStatus: {
        isIDCard: 1, // 活体检验:是否身份证报名
        isPhoto: 2, // 人脸比对:拍照校验
        isFail: 3 // 自证视频校验
      },
      finger: '',
      showCamera: false,
      videoWidth: 438,
      videoHeight: 318,
      tipTitle: '请保持正脸对准框内',
      isOpenCamera: false, // 是否打开摄像头
      faceCheckLoading: false, // 拍照识别loading
      hasFaceResult: false, // 拍照识别是否有结果
      faceSuccess: false, // 拍照识别是否成功
      showCameraErrorTip: false, // 打开摄像头异常提示
      photoPath: ''
    }
  },
  async mounted() {
    try {
      // 为了兼容从其他系统直接跳转过来拿不到 localStorage 的情况
      if (this.$route.query.examId) {
        localStorage.setItem('examId', this.$route.query.examId)
      }

      this.examId = localStorage.examId
      this.photoPath = `eduTest/identityCheck/${this.examId}`
      this.finger = this.$store.state.browserFinger
      if (!this.examId) {
        this.$message.error('未找到相应考试，请从考试入口进入')
        this.$router.push({ name: 'list' })
        return
      }
      await this.verification()
      if (this.identityWay === 1 || this.identityWay === 2) { // 打开摄像头
        this.$refs.checkCamera.getCompetence()
        this.isOpenCamera = true
      }
      // 废弃腾讯活体检测逻辑
      // const url = location.search
      // if (url.indexOf('?') !== -1) {
      //   await this.getLivingBodyResult(url)
      // }
      this.$store.dispatch('setMonitorReport', { type: 1 }) // 上报考试监控埋点，进入身份核验
    } catch (e) {
      this.$router.push({ name: 'home' })
    }
  },
  destroyed() {
    clearInterval(this.timer)
    this.closeVideo()
  },
  methods: {
    // 人脸核验状态
    async verification () {
      const data = await get(`/home/face-verification/${this.examId}/face/${this.user.id}/state`, { deviceId: this.$store.state.browserFinger })
      this.identityWay = data.assayType
    },
    // 跳转腾讯活体识别 废弃
    async goToTencent () {
      const params = {
        userId: this.user.id,
        examId: this.examId,
        deviceId: this.finger,
        callbackUrl: window.CONFIG.edu_test + '/identityCheck'
      }
      try {
        const { jumpUrl } = await get(`/home/face-verification/living-body/token`, params)
        window.open(jumpUrl, '_self')
      } catch (error) {
        this.$message.warning('检测到身份证/姓名信息与公安系统不一致，请录屏核验身份')
        this.identityWay = this.identityStatus.isFail
      }
    },
    // 根据链接参数获取活体识别结果 废弃
    async getLivingBodyResult(url) {
      const params = {
        userId: this.user.id,
        examId: this.examId,
        deviceId: this.finger
      }
      // 获取回调参数
      const str = url.substr(1)
      const strs = str.split('&')
      for (let i = 0; i < strs.length; i++) {
        params[strs[i].split('=')[0]] = strs[i].split('=')[1]
      }
      // 根据参数判断是否通过
      const { pass } = await post(`/home/face-verification/living-body/submit`, params)
      if (pass) { // 活体检测通过
        this.$emit('nextStep', 1)
      } else { // 活体检测失败，跳转录制视频
        this.identityWay = this.identityStatus.isFail
      }
    },
    // 打开摄像头
    openVideo() {
      this.showCamera = true
    },
    // 摄像头有问题
    handleError() {
      this.isOpenCamera = false
      this.showCameraErrorTip = true
    },
    // 拍照
    getPhoto() {
      this.$refs.checkCamera.setImage()
    },
    // 摄像头拍照图片链接
    async setCameraImg(url) {
      this.faceCheck(url)
    },
    // 提交照片识别对比
    async faceCheck(url) {
      this.faceCheckLoading = true
      const params = {
        userId: this.user.id,
        examId: this.examId,
        deviceId: this.finger,
        photoUrl: url
      }
      const { pass } = await post(`/home/face-verification/face-contrast/submit`, params)
      this.hasFaceResult = true
      this.faceSuccess = pass
      if (!pass) { // 不通过
        this.tipTitle = '照片识别失败'
      } else {
        this.timer = setInterval(() => {
          clearInterval(this.timer)
          this.$emit('nextStep', 1)
        }, 500)
      }
      this.faceCheckLoading = false
    },
    success () {
      this.$emit('nextStep', 1)
    },
    // 关闭摄像头
    closeVideo() {
      if (this.$refs.checkCamera) {
        this.$refs.checkCamera.stopNavigator()
      }
    },
    // 跳过照片识别
    goToVideoCheck() {
      this.identityWay = this.identityStatus.isFail
    }
  }
}
</script>

<style lang="scss" scoped>
  .check-wrap {
    margin: 0 auto;
    width: 872px;
  }
  .body-check {
    margin-top: 88px;
  }
  h1 {
    letter-spacing: 0;
  }
  .fill-btn {
    @include theme-fill-btn(144px, 42px, 16px, 4px);
    margin-top: 40px;
  }
  .empty-btn {
    @include theme-empty-btn(144px, 42px, 16px, 4px);
    margin: 40px 40px 0 0;
  }
  .photo-check {
    margin-top: 48px;
  }
  .camera-wrap {
    position: relative;
    background: rgba(0, 0, 0, .1);
    width: 440px;
    height: 320px;
    border-radius: 8px;
  }
  .no-camera {
    height: 100%;
    .box {
      display: inline-block;
      position: absolute;
      width: 50px;
      height: 20px;
      border: 2px solid #fff;
      opacity: .8;
    }
    .left-top {
      left: 30px;
      top: 30px;
      border-right: 0;
      border-bottom: 0;
    }
    .left-bottom {
      left: 30px;
      bottom: 30px;
      border-right: 0;
      border-top: 0;
    }
    .right-top {
      right: 30px;
      top: 30px;
      border-left: 0;
      border-bottom: 0;
    }
    .right-bottom {
      right: 30px;
      bottom: 30px;
      border-left: 0;
      border-top: 0;
    }
  }
  .icon-camera {
    display: inline-block;
    width: 54px;
    height: 46px;
    background: url("~@/assets/images/identityCheck/icon-camera.png") center / cover no-repeat;
  }
  .camera {
    /deep/ video {
      border-radius: 8px;
    }
  }
  .operate-wrap {
    width: 380px;
    padding-top: 20px;
  }
  .tip-wrap {
    text-align: left;
    margin-top: 100px;
    .title {
      font-weight: 500;
    }
  }
  .btn-disabled {
    width: 144px;
    height: 42px;
    background: #B5C6E4;
    border-radius: 4px;
    box-shadow: none !important;
    cursor: not-allowed;
    &:hover {
      background: #B5C6E4;
    }
  }
  .loading-wrap {
    text-align: center;
    margin-top: 68px;
    /deep/ .spinner {
      margin: 50px auto auto;
    }
  }
  .face-success {
    text-align: center;
    margin: 20px auto auto;
    .icon-success {
      width: 160px;
      height: 112px;
      margin: 25px auto 43px auto;
      background: url("~@/assets/images/detect/success.png") center / cover no-repeat;
    }
  }
</style>
